import { render, staticRenderFns } from "./Subpanel.vue?vue&type=template&id=798362d6&scoped=true"
import script from "./Subpanel.vue?vue&type=script&lang=js"
export * from "./Subpanel.vue?vue&type=script&lang=js"
import style0 from "./Subpanel.vue?vue&type=style&index=0&id=798362d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798362d6",
  null
  
)

export default component.exports